import { createSlice, createSelector } from '@reduxjs/toolkit';
import { RootState } from '~/store';

const initialState: { isLoading: boolean[] } = {
  isLoading: [],
};

export const NOT_LOADING_APIS: { api: string; endpointName: string }[] = [
  { api: 'onePassApi', endpointName: 'getQrcodeTicket' },
];

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    openLoading: state => {
      state.isLoading = state.isLoading.concat(true);
      // 假設同時有複數個 api，需要 loading 的時候就加上一個 true
    },
    closeLoading: state => {
      state.isLoading = state.isLoading.slice(1);
      // 一但不需要 loading 之後就刪掉一個 true
    },
  },
});

export const getterIsLoading = createSelector(
  (state: RootState) => state.loading.isLoading,
  isLoading => isLoading.some(Boolean), // 直到所有需要 loading 的事情都結束才 !isLoading
);

export const { openLoading, closeLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
